// Configuración de la conexión P2P (WebRTC vía PeerJS).
//
// Señalización: BROKER PÚBLICO de PeerJS (todo estático, sin servidor propio).
const USE_OWN_SERVER = false;
const OWN_HOST = null;      // p. ej. 'tudominio.com' (o null = mismo host que la web)
const PATH = '/palabriks';
const DEV_PORT = 9000;

// --- TURN de Cloudflare (relay FIABLE para DATOS MÓVILES / 4G-5G) ---
// Con solo STUN, la conexión directa falla en redes con NAT simétrico/CGNAT (datos
// móviles): funcionaba en WiFi pero no en 4G. Un Worker de Cloudflare entrega
// credenciales TURN frescas y de corta duración de turn.cloudflare.com. Es lo que
// hace que el online funcione siempre. (Mismo Worker que usa CROMOS FUTBOL.)
const CF_WORKER_URL = 'https://wcsa-turn.jordimesagonzalez.workers.dev';
const CF_CACHE_KEY = 'palabriks_cf_turn';

function cfCached() {
  try {
    const raw = localStorage.getItem(CF_CACHE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (o.expiresAt && o.expiresAt - Date.now() > 5 * 60 * 1000) return o.servers;
  } catch { /* noop */ }
  return null;
}

/** Pide credenciales TURN frescas de Cloudflare (usa caché si aún vale). Se llama al
 *  arrancar (para tenerlas listas) y justo antes de conectar. Devuelve el array o null. */
export async function refreshCloudflareTurn() {
  const cached = cfCached();
  if (cached) return cached;
  try {
    const res = await fetch(CF_WORKER_URL, { method: 'GET', cache: 'no-cache' });
    if (!res.ok) return null;
    const data = await res.json();
    if (!data || !data.iceServers) return null;
    const arr = Array.isArray(data.iceServers) ? data.iceServers : [data.iceServers];
    const expiresAt = data.expiresAt || (Date.now() + 50 * 60 * 1000);
    try { localStorage.setItem(CF_CACHE_KEY, JSON.stringify({ servers: arr, expiresAt })); } catch { /* noop */ }
    return arr;
  } catch { return null; }
}

const STUN = [
  { urls: 'stun:stun.l.google.com:19302' },
  { urls: 'stun:stun1.l.google.com:19302' },
  { urls: 'stun:stun.cloudflare.com:3478' },
];
// TURN público de reserva (por si el Worker de Cloudflare no responde). Poco fiable.
const PUBLIC_TURN = [
  { urls: 'turn:staticauth.openrelay.metered.ca:80', username: 'openrelayproject', credential: 'openrelayproject' },
  { urls: 'turn:staticauth.openrelay.metered.ca:443', username: 'openrelayproject', credential: 'openrelayproject' },
  { urls: 'turns:staticauth.openrelay.metered.ca:443?transport=tcp', username: 'openrelayproject', credential: 'openrelayproject' },
];

function iceServers() {
  const cf = cfCached() || [];      // Cloudflare TURN primero (relay principal)
  return [...cf, ...STUN, ...PUBLIC_TURN];
}

/** Opciones para `new Peer(...)`. ASÍNCRONA: asegura credenciales TURN de Cloudflare
 *  antes de conectar (imprescindible para datos móviles). */
export async function getPeerOptions() {
  await refreshCloudflareTurn();
  const iceConfig = { config: { iceServers: iceServers() } };
  if (!USE_OWN_SERVER) return iceConfig;

  const host = OWN_HOST || (typeof location !== 'undefined' ? location.hostname : 'localhost');
  const isLocal = host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local');
  const secure = typeof location !== 'undefined' && location.protocol === 'https:';
  const port = isLocal
    ? DEV_PORT
    : (typeof location !== 'undefined' && location.port ? Number(location.port) : (secure ? 443 : 80));
  return { host, port, path: PATH, secure, ...iceConfig };
}
